// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-7ebba3fd&scoped=true!./~/less-loader?sourceMap!./~/vue-loader/lib/selector.js?type=style&index=1!./src/components/clients/SelectContactsModal.vue
// module id = 452
// module chunks = 0